import IframeModal from "./iframe-modal";

export default class PaymentModal extends IframeModal {
  #url;

  constructor(paymentUrl) {
    super();
    this.#url = paymentUrl;
  }

  async requestPayment() {
    this.autoResizeHeight = false;
    await this.open("Pay your deposit", this.#url);

    let lastErr = "";
    let retryingPayment = true;
    let paid = false;
    while (retryingPayment) {
      try {
        // eslint-disable-next-line no-await-in-loop
        await this.awaitSuccessStatus();
        paid = true;
        retryingPayment = false;
      } catch (error) {
        if (error.message === "Aborted") {
          retryingPayment = false;
          error.message = "Payment cancelled.";
        }

        lastErr = error;
      }
    }

    if (!paid) {
      throw lastErr;
    }

    // Payment Success
  }
}
